/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { api } from './api';

interface IAdminPlan {
  id: string;
  name: string;
  price: number;
  description: string;
  max_users: number | null;
  max_exercises: number | null;
  max_news: number | null;
}

interface IAdminPlanFeature {
  feature_id: string;
  nome: string;
  code: string;
  value: number | null;
}

interface IAdminPlanDetail {
  subscription: IAdminPlan;
  features: IAdminPlanFeature[];
}

interface IUpdatePlanParams {
  price: number;
  description: string;
}

class AdminPlansService {
  private apiService = api;

  public async getPlans() {
    return this.apiService.get<IAdminPlan[]>('admin/plans');
  }

  public async getPlan(plan_id: string) {
    return this.apiService.get<IAdminPlanDetail>(`admin/plans/${plan_id}`);
  }

  public async updatePlan(plan_id: string, data: IUpdatePlanParams) {
    return this.apiService.put<IAdminPlan>(`admin/plans/${plan_id}`, data);
  }

  public async updateFeatureValue(
    plan_id: string,
    feature_id: string,
    value: number | null,
  ) {
    return this.apiService.put(
      `admin/plans/${plan_id}/features/${feature_id}`,
      { value },
    );
  }
}

export { AdminPlansService };
export type { IAdminPlan, IAdminPlanFeature, IAdminPlanDetail };
